import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL, Image_URL } from "../config";
import RequestforpriceForm from "../components/Requetforprice";

const RequestDetails = () => {
  const { orderId } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [forceUpdate, setForceUpdate] = useState(0);

  const [showRFP, setShowRFP] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const fetchOrderDetails = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Price/GetRequestforOrderDetails?OrderItemID=${orderId}`
      );
      if (!response.ok) throw new Error("Failed to fetch order details.");
      const json = await response.json();
      setOrders(json?.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId, forceUpdate]);



  useEffect(() => {
    const update = () => setForceUpdate((p) => p + 1);

    window.addEventListener("storage", update);
    window.addEventListener("activeViewChanged", update);
    window.addEventListener("markupTableChanged", update);

    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("activeViewChanged", update);
      window.removeEventListener("markupTableChanged", update);
    };
  }, []);


  const openImagePopup = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setSelectedImage(null);
    setShowImagePopup(false);
  };



  const openRequestForPrice = (product) => {
    setSelectedProduct(product);
    setShowRFP(true);
  };

  const closeRequestForPrice = () => {
    setSelectedProduct(null);
    setShowRFP(false);
  };


  const groupedItems = orders;
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-";
    return d.toLocaleDateString();
  };
// ACCEPT
const handleConfirmAccept = (product) => {
  const isConfirmed = window.confirm(
    "Are you sure you want to approve this order?"
  );

  if (isConfirmed) {
    handleAccept(product);
  }
};

// CANCEL
const handleConfirmCencal = (product) => {
  const isConfirmed = window.confirm(
    "Are you sure you do not want to proceed with this product?"
  );

  if (isConfirmed) {
    handleCencal(product);
  }
};



const handleAccept = async (product) => {
  try {
    const requestBody = {
      Id: product.RequestId,
      CompanyId: product.CompanyId,
      ModifiedBy: "Customer",
      Status: "Order Approved",
    };

    const formData = new FormData();
    formData.append("modelJson", JSON.stringify(requestBody));

    const response = await fetch(
      `${API_BASE_URL}/Price/AcceptOrRejectRequestforPrice`,
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (response.ok) {
      alert(result.message || "Order approved successfully!");
      fetchOrderDetails();
    } else {
      alert("Error: " + result.message);
    }
  } catch (error) {
    console.error("Error approving order:", error);
    alert("An error occurred while approving the order.");
  }
};


// NOT PROCEEDING
const handleCencal = async (product) => {
  try {
    const requestBody = {
      Id: product.RequestId,
      ModifiedBy: "Customer",
      Status: "Not Proceeding",
    };

    const formData = new FormData();
    formData.append("modelJson", JSON.stringify(requestBody));

    const response = await fetch(
      `${API_BASE_URL}/Price/AcceptOrRejectRequestforPrice`,
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (response.ok) {
      alert(result.message || "Request cancelled successfully!");
      fetchOrderDetails();
    } else {
      alert("Error: " + result.message);
    }
  } catch (error) {
    console.error("Error cancelling request:", error);
    alert("An error occurred while cancelling the request.");
  }
};


  if (loading) return <p>Loading order details...</p>;
  if (error) return <p>{error}</p>;
  if (!orders.length) return <p>No order details available.</p>;


  return (
    <>
      <div className="home">
        <Header />

        <div className="section-padding">
          <div className="section-container p-l-r">
            <h2 className="text-center">
              <Link to="/requestforpriceview" style={{ color: "black" }} className="btn btn-view">
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
              </Link>{" "}
              Price Request Details
            </h2>

            {/* Order Summary */}


            {groupedItems.length > 0 ? (
              groupedItems.map((product, index) => (
                <div key={index}>
                  <div className="order-info-container">
                    {/* ORDER INFO – rendered once for each product group */}
                    <div
                      className="info-above"
                      style={{
                        backgroundColor:
                          product.UpdatedBy === "Admin"
                            ? "#aed0f4"
                            : product.UpdatedBy === "Customer" || product.CreatedBy === "Customer"
                              ? "#ffb13e"
                              : "transparent"
                      }}
                    >
                      <div className="order-id">
                        <p>RequestId Id</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {product.RequestId} - {product.ProductCode}
                        </p>
                      </div>

                      <div className="placed">
                        <p>Request Date</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          {new Date(product.CreatedDate).toLocaleDateString()}
                        </p>
                      </div>

                      <div className="order-total">
                        <p>Metal</p>
                        <p style={{ fontWeight: "bold" }}>{product.MetalKT} {product.MetalColor}</p>
                      </div>

                      <div className="placed">
                        <p>Carat</p>
                        <p style={{ fontWeight: "bold" }}>{product.Carat}</p>
                      </div>

                      <div className="placed">
                        <p>Diamond</p>
                        <p style={{ fontWeight: "bold" }}>
                          {product.DiamondType}
                        </p>
                      </div>
                      <div className="placed">
                        <p>Colour</p>
                        <p style={{ fontWeight: "bold" }}>{product.Color}</p>
                      </div>

                      <div className="placed">
                        <p>Clarity</p>
                        <p style={{ fontWeight: "bold" }}>{product.Clarity}</p>
                      </div>

                      <div className="order-total">
                        <p>Total Amount</p>
                        <p style={{ fontWeight: "bold", color: "#565656" }}>
                          AUD
                          {Math.round(product.AdminPrice)}
                          {/* {Math.round(applyMarkup(order.AdminPrice))} */}

                        </p>
                      </div>

                       <div className="order-status">
                                  {product.Status === "Pending" ? (
                                    <>
                                      <button onClick={() => handleConfirmCencal(product)} className="btn btn-primary">
                                        Not Proceeding
                                      </button>
                                    </>
                                  ) : (
                                    ["Inquiry Accepted", "CAD Design Submitted", "Update Delivery Date"].includes(product.Status) ? (
                                      <>
                                        <button onClick={() => handleConfirmAccept(product)} className="btn btn-primary">
                                          Approve Order
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <p></p>
                                        <p>
                                          <b style={{ color: "blue", textAlign: "center" }}>
                                            {["order approved", "order in production"].includes(product.Status.toLowerCase().trim()) ? product.Status : null}
                                          </b>
                                        </p>
                                      </>
                                    )
                                  )}
                                 
                                </div>
                    </div>
                    <hr />
                    {/* PRODUCT DETAILS */}
                    <div className="info-below">
                      <div className="img-and-info">

                        <div>
                          <img
                            src={product.ProductImg || `${Image_URL}/placeholder.png`}
                            alt={product.ProductCode}
                            onClick={() => openImagePopup(product.ProductImg)}
                            style={{ cursor: "pointer", width: "150px" }}
                          />

                          <div className="delivery-status">
                            <h4>Delivery Status</h4>
                            <h6
                              className={
                                product.Status === "Delivered"
                                  ? "delivered"
                                  : "transit"
                              }
                            >
                              {product.Status}
                            </h6>
                          </div>
                        </div>

                        <div className="order-status-content">

                          <p>
                            Order Comments:{" "}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: product.Comment || "No comments",
                              }}
                            />
                          </p>

<p>Status Updated On: <strong>{formatDate(product.UpdatedOn)}</strong></p>



                          <div className="info-above">

                            <div className="placed">
                              <p>Updated By</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.UpdatedBy || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Admin Comment</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.AdminComment || "-"}
                              </p>
                            </div>






                            {/* NEW FIELDS */}
                            <div className="placed">
                              <p>Approx Delivery Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.AdminDeliverydate)}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Dispatch Through</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.DispatchThrough || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Dispatch Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.DispatchDate)}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Tracking ID</p>
                              <p style={{ fontWeight: "bold" }}>
                                {product.TrackingId || "-"}
                              </p>
                            </div>

                            <div className="placed">
                              <p>Delivery Date</p>
                              <p style={{ fontWeight: "bold" }}>
                                {formatDate(product.AdminDeliverydate)}
                              </p>
                            </div>
                            <button
                              className="btn btn-primary"
                              onClick={() => openRequestForPrice(product)}
                            >
                              Edit
                            </button>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No products in this order.</p>
            )}




          </div>
        </div>
        {/* Product Image Popup */}
        {showImagePopup && selectedImage && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button onClick={closeImagePopup}>Close</button>
              <img src={selectedImage} alt="Expanded Product" style={{ width: "900px" }} />
            </div>
          </div>
        )}

        {showRFP && selectedProduct && (
          <div className="popup-overlay">
            <div className="popup-content" style={{ width: "700px" }}>


              <RequestforpriceForm
                productId={selectedProduct.ProductId}
                productCode={selectedProduct.ProductCode}
                designCode={selectedProduct.DesignNo}
                productImg={selectedProduct.ProductImg}
                requestId={selectedProduct.RequestId}
                initialValues={selectedProduct}
                onClose={closeRequestForPrice}
              />
            </div>
          </div>
        )}



        <Footer />
      </div>
    </>
  );
};

export default RequestDetails;
